import {
  CreatePickerEmpMap,
  PickerEmpList,
  PickerList,
} from 'components/pickerEmpMap'
import { useCallback, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useSearchParams } from 'react-router-dom'

const TABS = [
  { id: 'mappings', label: 'Picker Names' },
  { id: 'pickers', label: 'Pickers' },
]

const PickerEmpMapPage = () => {
  const [refetch, setRefetch] = useState<boolean>(false)
  const [searchParams, setSearchParams] = useSearchParams()

  const activeTab =
    searchParams.get('tab') === 'pickers' ? 'pickers' : 'mappings'

  const refetchMappings = useCallback(() => {
    setRefetch((prev) => !prev)
  }, [setRefetch])

  // Each tab has its own page and filters, so they reset on switch
  const switchTab = (tab: string) => setSearchParams({ tab })

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Picker Mapping Management</title>
      </Helmet>

      <div className="w-full">
        <div className="mb-4 flex gap-2 border-b border-gray-200">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => switchTab(tab.id)}
              className={`-mb-px border-b-2 px-4 py-2 text-sm font-semibold ${
                activeTab === tab.id
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {activeTab === 'pickers' ? (
          <PickerList />
        ) : (
          <>
            <CreatePickerEmpMap refetchMappings={refetchMappings} />
            <PickerEmpList refetch={refetch} />
          </>
        )}
      </div>
    </>
  )
}

export default PickerEmpMapPage
